export enum E_CHECKBOX_GROUP_MODE {
  SINGLE = 'single',
  MULTIPLE = 'multiple'
};

export enum E_STEP_NAME {
  APPROVAL = 'approval',
  EDITOR = 'editor',
  VDP_TABLE = 'vdp-table',
};
